export default __webpack_public_path__ + "static/media/Sara_Icon.76297a27.png";